const Api = {
  //live
  BASEURL: 'https://backapi.symang.in/api/'

  //local
  // BASEURL: 'http://192.168.1.29/api/'
};
export default Api;
